import { render, staticRenderFns } from "./ImagenesOT.vue?vue&type=template&id=5d1d80da&"
import script from "./ImagenesOT.vue?vue&type=script&lang=js&"
export * from "./ImagenesOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports